import React from 'react';

var ArrowRight2 = (function (_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '1em' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '1em' : _ref$height,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? 'currentcolor' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    d: "M19.414 27.414l10-10c0.781-0.781 0.781-2.047 0-2.828l-10-10c-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828l6.586 6.586h-19.172c-1.105 0-2 0.895-2 2s0.895 2 2 2h19.172l-6.586 6.586c-0.39 0.39-0.586 0.902-0.586 1.414s0.195 1.024 0.586 1.414c0.781 0.781 2.047 0.781 2.828 0z"
  }));
});

export { ArrowRight2 as default };
//# sourceMappingURL=ArrowRight2.js.map
